(function () {
  var SELECTOR = '[data-price-info-tooltip]';
  var BTN_SELECTOR = '[data-price-info-btn]';
  var HOVER_HIDE_DELAY = 80;
  var hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  var portal = null;
  var bubble = null;
  var activeRoot = null;
  var hideDelayTimer = null;

  function canHover() {
    return hoverQuery.matches;
  }

  function ensurePortal() {
    if (portal && bubble && document.body.contains(portal)) return;
    portal = document.createElement('div');
    portal.className = 'price-info-tooltip__portal';
    bubble = document.createElement('div');
    bubble.className = 'price-info-tooltip__bubble';
    bubble.setAttribute('role', 'tooltip');
    portal.appendChild(bubble);
    document.body.appendChild(portal);
  }

  function clearTimers() {
    if (hideDelayTimer) {
      clearTimeout(hideDelayTimer);
      hideDelayTimer = null;
    }
  }

  function hide() {
    clearTimers();

    if (activeRoot) {
      activeRoot.classList.remove('is-open');
      var btn = activeRoot.querySelector(BTN_SELECTOR);
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }

    if (bubble) bubble.classList.remove('is-visible');
    activeRoot = null;
  }

  function position() {
    if (!activeRoot || !bubble) return;
    var btn = activeRoot.querySelector(BTN_SELECTOR);
    if (!btn) return;

    var rect = btn.getBoundingClientRect();
    var gap = 10;
    var bubbleRect = bubble.getBoundingClientRect();
    var width = bubbleRect.width || bubble.offsetWidth;
    var height = bubbleRect.height || bubble.offsetHeight;
    var centerX = rect.left + rect.width / 2;
    var minX = 12 + width / 2;
    var maxX = window.innerWidth - 12 - width / 2;
    var left = Math.min(Math.max(centerX, minX), maxX);

    var placeBelow = rect.top < height + gap + 8;
    var top = placeBelow ? rect.bottom + gap : rect.top - height - gap;

    bubble.style.left = left + 'px';
    bubble.style.top = Math.max(8, top) + 'px';
    bubble.classList.toggle('is-below', placeBelow);
  }

  function show(root) {
    if (!root) return;
    var text = root.getAttribute('data-tooltip');
    if (!text) return;

    ensurePortal();
    clearTimers();

    if (activeRoot && activeRoot !== root) {
      activeRoot.classList.remove('is-open');
      var prevBtn = activeRoot.querySelector(BTN_SELECTOR);
      if (prevBtn) prevBtn.setAttribute('aria-expanded', 'false');
    }

    activeRoot = root;
    root.classList.add('is-open');
    var btn = root.querySelector(BTN_SELECTOR);
    if (btn) btn.setAttribute('aria-expanded', 'true');

    bubble.textContent = text;
    position();
    requestAnimationFrame(function () {
      if (activeRoot !== root) return;
      bubble.classList.add('is-visible');
      position();
    });
  }

  function toggle(root) {
    if (activeRoot === root) {
      hide();
      return;
    }
    show(root);
  }

  function scheduleHide() {
    clearTimers();
    hideDelayTimer = setTimeout(function () {
      hide();
    }, HOVER_HIDE_DELAY);
  }

  document.addEventListener('mouseover', function (event) {
    if (!canHover()) return;
    var root = event.target.closest(SELECTOR);
    if (!root) return;
    show(root);
  });

  document.addEventListener('mouseout', function (event) {
    if (!canHover()) return;
    var root = event.target.closest(SELECTOR);
    if (!root || root !== activeRoot) return;
    if (root.contains(event.relatedTarget)) return;
    scheduleHide();
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest(BTN_SELECTOR);
    var root = event.target.closest(SELECTOR);

    if (btn && root) {
      event.preventDefault();
      event.stopPropagation();
      if (canHover()) {
        show(root);
        return;
      }
      toggle(root);
      return;
    }

    if (!root) hide();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') hide();
  });

  window.addEventListener('scroll', function () {
    if (activeRoot) position();
  }, true);

  window.addEventListener('resize', function () {
    if (activeRoot) position();
  });

  if (hoverQuery.addEventListener) {
    hoverQuery.addEventListener('change', hide);
  }
})();
